import { APIErrorResponseSchema, SideEffectSchema, V2ErrorResponseSchema, errorAction, generateConst, loadingAction, successSideEffectState } from ".";
import { AppBasicInfoSchema } from "./authActions";

type ActionType = "EmailToAdmin" | "BlockTheUser" | "SecondFactorAuthentication";
export interface RiskFactor {
  IsEnabled: boolean;
  TimeRange: number;
  TimeRangeUnit: "Days" | "Hours"; // Assuming "Days" is not the only possible unit
  Actions?: ActionType[];
}

interface RiskFactors {
  City: RiskFactor;
  Country: RiskFactor;
  Ip: RiskFactor;
  Browser: RiskFactor;
  Device: RiskFactor;
}

export interface RiskAuthSchema extends SideEffectSchema, V2ErrorResponseSchema {
  SecondFactorAuthenticationMethod?: "Email" | "SMS" | "Authenticator"; // You can add more methods if needed
  RiskFactors: RiskFactors;
  EmailAddresses?: string[] | null;
  action?: string;
}
export interface PinAuthSchema extends SideEffectSchema, V2ErrorResponseSchema {
  IsRequired: boolean;
  AskOnRegistration: boolean;
  AskOnLogin: boolean;
  AskOnlyOnFirstLogin: boolean;
  PINLogin: boolean;
  SessionTokenExpiration: number;
}
export interface UpdatePinAuthSchema extends SideEffectSchema, V2ErrorResponseSchema {
  IsPosted: boolean;
}
export interface MFAActionSchema {
  isEnabled: boolean;
}

interface QuestionData {
  key: string;
  question: string;
}
export interface SecurityQuestionSchema extends SideEffectSchema {
  Data: {
    questions: QuestionData[];
    renderCount: number;
    limit: number;
    message?: string;
    isCountUpdate?: boolean;
  };
}
export const SecurityQuestionAction = {
  FETCH_QUESTIONS_REQUEST: "FETCH_QUESTIONS_REQUEST",
  FETCH_QUESTIONS_SUCCESS: "FETCH_QUESTIONS_SUCCESS",
  FETCH_QUESTIONS_ERROR: "FETCH_QUESTIONS_ERROR",
  ADD_QUESTION_REQUEST: "ADD_QUESTION_REQUEST",
  ADD_QUESTION_SUCCESS: "ADD_QUESTION_SUCCESS",
  ADD_QUESTION_ERROR: "ADD_QUESTION_ERROR",
  UPDATE_QUESTION_REQUEST: "UPDATE_QUESTION_REQUEST",
  UPDATE_QUESTION_SUCCESS: "UPDATE_QUESTION_SUCCESS",
  UPDATE_QUESTION_ERROR: "UPDATE_QUESTION_ERROR",
  DELETE_QUESTION_REQUEST: "DELETE_QUESTION_REQUEST",
  DELETE_QUESTION_SUCCESS: "DELETE_QUESTION_SUCCESS",
  DELETE_QUESTION_ERROR: "DELETE_QUESTION_ERROR",
  UPDATE_COUNT_LIMIT_REQUEST: "UPDATE_COUNT_LIMIT_REQUEST",
  UPDATE_COUNT_LIMIT_SUCCESS: "UPDATE_COUNT_LIMIT_SUCCESS",
  UPDATE_COUNT_LIMIT_FAILURE: "UPDATE_COUNT_LIMIT_FAILURE"
};

export const fetchQuestionsRequest = () => ({
  type: SecurityQuestionAction.FETCH_QUESTIONS_REQUEST
});

export const addQuestionRequest = (question) => ({
  type: SecurityQuestionAction.ADD_QUESTION_REQUEST,
  payload: question
});

export const updateQuestionRequest = (question) => ({
  type: SecurityQuestionAction.UPDATE_QUESTION_REQUEST,
  payload: question
});

export const deleteQuestionRequest = (questionId) => ({
  type: SecurityQuestionAction.DELETE_QUESTION_REQUEST,
  payload: questionId
});

export const updateCountLimitRequest = (data) => ({
  type: SecurityQuestionAction.UPDATE_COUNT_LIMIT_REQUEST,
  payload: data
});

export const updateCountLimitSuccess = (data: any) => ({
  type: SecurityQuestionAction.UPDATE_COUNT_LIMIT_SUCCESS,
  payload: data
});

export const updateCountLimitFailure = (error: any) => ({
  type: SecurityQuestionAction.UPDATE_COUNT_LIMIT_FAILURE,
  payload: error
});

export const PasswordPolicyAction = {
  GET_APP_INFO: "GET_APP_INFO",
  GET_APP_INFO_LOADING: "GET_APP_INFO_LOADING",
  GET_APP_INFO_ERROR: "GET_APP_INFO_ERROR",
  GET_APP_INFO_SUCCESS: "GET_APP_INFO_SUCCESS",

  GET_PASSWORD_COMPLEXITY: "GET_PASSWORD_COMPLEXITY",
  GET_PASSWORD_COMPLEXITY_LOADIN: "GET_PASSWORD_COMPLEXITY_LOADIN",
  GET_PASSWORD_COMPLEXITY_ERROR: "GET_PASSWORD_COMPLEXITY_ERROR",
  GET_PASSWORD_COMPLEXITY_SUCCESS: "GET_PASSWORD_COMPLEXITY_SUCCESS",
  GET_PERIODIC_PASSWORD: "GET_PERIODIC_PASSWORD",
  GET_PERIODIC_PASSWORD_LOADING: "GET_PERIODIC_PASSWORD",
  GET_PERIODIC_PASSWORD_ERROR: "GET_PERIODIC_PASSWORD_ERROR",
  GET_PERIODIC_PASSWORD_SUCCESS: "GET_PERIODIC_PASSWORD_SUCCESS",

  PUT_PERIODIC_PASSWORD: "PUT_PERIODIC_PASSWORD",
  PUT_PERIODIC_PASSWORD_LOADING: "PUT_PERIODIC_PASSWORD",
  PUT_PERIODIC_PASSWORD_ERROR: "PUT_PERIODIC_PASSWORD_ERROR",
  PUT_PERIODIC_PASSWORD_SUCCESS: "PUT_PERIODIC_PASSWORD_SUCCESS",

  POST_PASSWORD_HISTORY_SETTINGS: "POST_PASSWORD_HISTORY_SETTINGS",
  POST_PASSWORD_HISTORY_SETTINGS_LOADING: "POST_PASSWORD_HISTORY_SETTINGS_LOADING",
  POST_PASSWORD_HISTORY_SETTINGS_ERROR: "POST_PASSWORD_HISTORY_SETTINGS_ERROR",
  POST_PASSWORD_HISTORY_SETTINGS_SUCCESS: "POST_PASSWORD_HISTORY_SETTINGS_SUCCESS",
  GET_BREACHED_PASSWORD_POLICY: "GET_BREACHED_PASSWORD_POLICY",
  GET_BREACHED_PASSWORD_POLICY_LOADING: "GET_BREACHED_PASSWORD_POLICY_LOADING",
  GET_BREACHED_PASSWORD_POLICY_ERROR: "GET_BREACHED_PASSWORD_POLICY_ERROR",
  GET_BREACHED_PASSWORD_POLICY_SUCCESS: "GET_BREACHED_PASSWORD_POLICY_SUCCESS",
  POST_BREACHED_PASSWORD_POLICY: "POST_BREACHED_PASSWORD_POLICY",
  POST_BREACHED_PASSWORD_POLICY_LOADING: "POST_BREACHED_PASSWORD_POLICY_LOADING",
  POST_BREACHED_PASSWORD_POLICY_ERROR: "POST_BREACHED_PASSWORD_POLICY_ERROR",
  POST_BREACHED_PASSWORD_POLICY_SUCCESS: "POST_BREACHED_PASSWORD_POLICY_SUCCESS",
  SYNC_BREACHED_PASSWORD_CONFIG: "SYNC_BREACHED_PASSWORD_CONFIG"
};
export const PinAuthAction = {
  PIN_AUTH: "PIN_AUTH",
  PIN_AUTH_LOADING: "PIN_AUTH_LOADING",
  PIN_AUTH_ERROR: "PIN_AUTH_ERROR",
  PIN_AUTH_SUCCESS: "PIN_AUTH_SUCCESS",
  UPDATE_PIN_AUTH: "UPDATE_PIN_AUTH",
  UPDATE_PIN_AUTH_LOADING: "UPDATE_PIN_AUTH_LOADING",
  UPDATE_PIN_AUTH_ERROR: "UPDATE_PIN_AUTH_ERROR",
  UPDATE_PIN_AUTH_SUCCESS: "UPDATE_PIN_AUTH_SUCCESS"
};
export const AppBasicSettingsAction = {
  UPDATE_APP_BASIC_INFO: "UPDATE_APP_BASIC_INFO",
  UPDATE_APP_BASIC_INFO_LOADING: "UPDATE_APP_BASIC_INFO_LOADING",
  UPDATE_APP_BASIC_INFO_ERROR: "UPDATE_APP_BASIC_INFO_ERROR",
  UPDATE_APP_BASIC_INFO_SUCCESS: "UPDATE_APP_BASIC_INFO_SUCCESS"
};

export const DomainAccessAction = {
  GET_DOMAIN_ACCESS: "GET_DOMAIN_ACCESS",
  GET_DOMAIN_ACCESS_LOADING: "GET_DOMAIN_ACCESS_LOADING",
  GET_DOMAIN_ACCESS_ERROR: "GET_DOMAIN_ACCESS_ERROR",
  GET_DOMAIN_ACCESS_SUCCESS: "GET_DOMAIN_ACCESS_SUCCESS",
  UPDATE_DOMAIN_ACCESS: "UPDATE_DOMAIN_ACCESS",
  UPDATE_DOMAIN_ACCESS_LOADING: "UPDATE_DOMAIN_ACCESS_LOADING",
  UPDATE_DOMAIN_ACCESS_ERROR: "UPDATE_DOMAIN_ACCESS_ERROR",
  UPDATE_DOMAIN_ACCESS_SUCCESS: "UPDATE_DOMAIN_ACCESS_SUCCESS"
};
export const SecurityQuestionsAction = generateConst("SECURITY_QUESTIONS", ["GET_SECURITY_QUESTIONS"]);

export const WebhookSecretsAction = generateConst("WEBHOOK_SECRETS", ["GET_WEBHOOK_SECRETS_OPTIONS"]);
export const MFASecurityQuestionsAction = generateConst("MFA_SECURITY_QUESTIONS", ["GET_MFA_SECURITY_QUESTIONS"]);

export const UpdateMFASecurityQuestionsAction = generateConst("MFA_SECURITY_QUESTIONS", ["UPDATE_MFA_SECURITY_QUESTIONS"]);

export const MFAAuthenticatorAppsAction = generateConst("MFA_AUTHENTICATOR_APPS", ["GET_MFA_AUTHENTICATOR_APPS"]);

export const UpdateMFAAuthenticatorAppsAction = generateConst("MFA_AUTHENTICATOR_APPS", ["UPDATE_MFA_AUTHENTICATOR_APPS"]);

export const mfaSettingsAction = generateConst("MFA_SETTINGS", ["GET_MFA_SETTINGS"]);

export const updateMFASettingsAction = generateConst("MFA_SETTINGS", ["UPDATE_MFA_SETTINGS"]);

export const mfaEmailOtpStatusAction = generateConst("MFA_EMAIL_STATUS", ["GET_MFA_EMAIL_STATUS"]);

export const updateMFAEmailOtpStatusAction = generateConst("MFA_EMAIL_STATUS", ["UPDATE_MFA_EMAIL_STATUS"]);

export const mfaSmsOtpStatusAction = generateConst("MFA_SMS_STATUS", ["GET_MFA_SMS_STATUS"]);

export const updateMFASmsOtpStatusAction = generateConst("MFA_SMS_STATUS", ["UPDATE_MFA_SMS_STATUS"]);

export const pushNotificationAction = generateConst("PUSH_NOTIFICATION", ["GET_PUSH_NOTIFICATION"]);

export const addpushNotificationAction = generateConst("PUSH_NOTIFICATION", ["ADD_PUSH_NOTIFICATION"]);

export const updatepushNotificationAction = generateConst("PUSH_NOTIFICATION", ["UPDATE_PUSH_NOTIFICATION"]);

export const duoAuthenticationAction = generateConst("DUO_AUTHENTICATION", ["GET_DUO_AUTHENTICATION"]);

export const getCaptchaSettingAction = generateConst("CAPTCHA_SETTING", ["GET_CAPTCHA_SETTING"]);

export const updateCaptchaSettingAction = generateConst("CAPTCHA_SETTING", ["UPDATE_CAPTCHA_SETTING"]);

export const updateduoAuthenticationAction = generateConst("DUO_AUTHENTICATION", ["UPDATE_DUO_AUTHENTICATION"]);

export const updateForceLogoutSettingConstAction = generateConst("FORCE_LOGOUT", ["UPDATE_FORCE_LOGOUT"]);

export const updateRemeberMeSettingConstAction = generateConst("REMEBER_ME", ["UPDATE_REMEBER_ME"]);

export const updateSessionLimitSettingAction = generateConst("SESSION_LIMIT", ["UPDATE_SESSION_LIMIT"]);

export const appBasicSettingsAction = (data) => {
  return {
    type: AppBasicSettingsAction.UPDATE_APP_BASIC_INFO,
    payload: { data: data }
  };
};

export const appBasicSettingsLoadingAction = () => loadingAction(AppBasicSettingsAction.UPDATE_APP_BASIC_INFO_LOADING);

export const appBasicSettingsErrorAction = (error: string) => errorAction(AppBasicSettingsAction.UPDATE_APP_BASIC_INFO_ERROR, error);

export const appBasicSettingsSuccessAction = (data: AppBasicInfoSchema) => {
  const payload: any = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: AppBasicSettingsAction.UPDATE_APP_BASIC_INFO_SUCCESS,
    payload
  };
};
export const RiskBasedAuthenticationAction = {
  GET_RISK_AUTH_SETTINGS: "GET_RISK_AUTH_SETTINGS",
  GET_RISK_AUTH_SETTINGS_LOADING: "GET_RISK_AUTH_SETTINGS_LOADING",
  GET_RISK_AUTH_SETTINGS_ERROR: "GET_RISK_AUTH_SETTINGS_ERROR",
  GET_RISK_AUTH_SETTINGS_SUCCESS: "GET_RISK_AUTH_SETTINGS_SUCCESS",

  UPDATE_RISK_AUTH_SETTINGS: "UPDATE_RISK_AUTH_SETTINGS",
  UPDATE_RISK_AUTH_SETTINGS_LOADING: "UPDATE_RISK_AUTH_SETTINGS_LOADING",
  UPDATE_RISK_AUTH_SETTINGS_ERROR: "UPDATE_RISK_AUTH_SETTINGS_ERROR",
  UPDATE_RISK_AUTH_SETTINGS_SUCCESS: "UPDATE_RISK_AUTH_SETTINGS_SUCCESS",

  GET_MFA_ACTIONS: "GET_MFA_ACTIONS",
  UPDATE_MFA_ACTIONS: "UPDATE_MFA_ACTIONS"
};
export const getMFAActions = () => {
  return {
    type: RiskBasedAuthenticationAction.GET_MFA_ACTIONS,
    payload: {}
  };
};
export const updateMFAActions = (data: MFAActionSchema) => {
  const payload: any = {
    ...data
  };
  return {
    type: RiskBasedAuthenticationAction.UPDATE_MFA_ACTIONS,
    payload
  };
};

export const getRiskAuthSettingsAction = () => {
  return {
    type: RiskBasedAuthenticationAction.GET_RISK_AUTH_SETTINGS,
    payload: {}
  };
};

export const getRiskAuthSettingsLoadingAction = () => loadingAction(RiskBasedAuthenticationAction.GET_RISK_AUTH_SETTINGS_LOADING);

export const getRiskAuthSettingsErrorAction = (error: string) => errorAction(RiskBasedAuthenticationAction.GET_RISK_AUTH_SETTINGS_ERROR, error);

export const getRiskAuthSettingsSuccessAction = (data: RiskAuthSchema) => {
  const payload: any = {
    ...data,
    ...successSideEffectState
  };
  if (!data.EmailAddresses) {
    payload["EmailAddresses"] = [];
  }
  return {
    type: RiskBasedAuthenticationAction.GET_RISK_AUTH_SETTINGS_SUCCESS,
    payload
  };
};

export const updateRiskAuthSettingsAction = (data) => {
  return {
    type: RiskBasedAuthenticationAction.UPDATE_RISK_AUTH_SETTINGS,
    payload: data
  };
};

export const updateRiskAuthSettingsLoadingAction = () => loadingAction(RiskBasedAuthenticationAction.UPDATE_RISK_AUTH_SETTINGS_LOADING);

export const updateRiskAuthSettingsErrorAction = (error: string) => errorAction(RiskBasedAuthenticationAction.UPDATE_RISK_AUTH_SETTINGS_ERROR, error);

export const updateRiskAuthSettingsSuccessAction = (data: RiskAuthSchema) => {
  const payload: any = {
    ...data,
    ...successSideEffectState
  };
  if (!data.EmailAddresses) {
    payload["EmailAddresses"] = [];
  }
  return {
    type: RiskBasedAuthenticationAction.UPDATE_RISK_AUTH_SETTINGS_SUCCESS,
    payload
  };
};
/**
 * APP INFO
 */

export interface AppInfoSchema extends SideEffectSchema {
  appInfo: any;
}
export const appInfoAction = () => {
  return {
    type: PasswordPolicyAction.GET_APP_INFO,
    payload: {}
  };
};

export const appInfoLoadingAction = () => loadingAction(PasswordPolicyAction.GET_APP_INFO_LOADING);

export const appInfoErrorAction = (error: string) => errorAction(PasswordPolicyAction.GET_APP_INFO_ERROR, error);

export const appInfoSuccessAction = (data: any) => {
  const payload: any = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: PasswordPolicyAction.GET_APP_INFO_SUCCESS,
    payload
  };
};

export interface PasswordCompliexitySchema extends SideEffectSchema {
  rules: string;
  clientIP: string;
}
export const getPasswordComplexityAction = () => {
  return {
    type: PasswordPolicyAction.GET_PASSWORD_COMPLEXITY,
    payload: {}
  };
};
export const getPasswordComplexityLoadingAction = () => loadingAction(PasswordPolicyAction.GET_PASSWORD_COMPLEXITY_LOADIN);

export const getPasswordComplexityErrorAction = (error: string) => errorAction(PasswordPolicyAction.GET_PASSWORD_COMPLEXITY_ERROR, error);

export const getPasswordComplexitySuccessAction = (data: PasswordCompliexitySchema) => {
  const payload: PasswordCompliexitySchema = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: PasswordPolicyAction.GET_PASSWORD_COMPLEXITY_SUCCESS,
    payload: payload
  };
};
//-----------------------------------------------------------------------------------
export const getPeriodicPasswordAction = () => {
  return {
    type: PasswordPolicyAction.GET_PERIODIC_PASSWORD,
    payload: {}
  };
};
export const getPeriodicPasswordLoadingAction = () => loadingAction(PasswordPolicyAction.GET_PERIODIC_PASSWORD_LOADING);

export const getPeriodicPasswordErrorAction = (error: string) => errorAction(PasswordPolicyAction.GET_PERIODIC_PASSWORD_ERROR, error);

export const getPeriodicPasswordSuccessAction = (data: any) => {
  const payload: any = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: PasswordPolicyAction.GET_PERIODIC_PASSWORD_SUCCESS,
    payload: payload
  };
};
//---------------------------------------------------------------------
export const getPinAuthAction = () => {
  return {
    type: PinAuthAction.PIN_AUTH,
    payload: {}
  };
};
export const getPinAuthLoadingAction = () => loadingAction(PinAuthAction.PIN_AUTH_LOADING);

export const getPinAuthErrorAction = (error: string) => errorAction(PinAuthAction.PIN_AUTH_ERROR, error);

export const getPinAuthSuccessAction = (data: any) => {
  const payload: any = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: PinAuthAction.PIN_AUTH_SUCCESS,
    payload: payload
  };
};
export const updatePinAuthAction = (data: PinAuthSchema) => {
  return {
    type: PinAuthAction.UPDATE_PIN_AUTH,
    payload: data
  };
};
export const updatePinAuthLoadingAction = () => loadingAction(PinAuthAction.UPDATE_PIN_AUTH_LOADING);

export const updatePinAuthErrorAction = (error: string) => errorAction(PinAuthAction.UPDATE_PIN_AUTH_ERROR, error);

export const updatePinAuthSuccessAction = (data: UpdatePinAuthSchema) => {
  const payload: UpdatePinAuthSchema = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: PinAuthAction.UPDATE_PIN_AUTH_SUCCESS,
    payload: payload
  };
};

export const getSecurityQuestionsAction = () => {
  return {
    type: SecurityQuestionsAction.GET_SECURITY_QUESTIONS,
    payload: {}
  };
};

export interface SecurityQuestionsSchema extends SideEffectSchema {
  Question?: any[];
  RenderCount?: any;
}
export const getSecurityQuestionsLoadingAction = () => loadingAction(SecurityQuestionsAction.GET_SECURITY_QUESTIONS_LOADING);

export const getSecurityQuestionsErrorAction = (error: string) => errorAction(SecurityQuestionsAction.GET_SECURITY_QUESTIONS_ERROR, error);

export const getSecurityQuestionsSuccessAction = (data: SecurityQuestionsSchema) => {
  const payload: SecurityQuestionsSchema = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: SecurityQuestionsAction.GET_SECURITY_QUESTIONS_SUCCESS,
    payload: payload
  };
};

export interface WebhookSecretsSchema extends SideEffectSchema {
  Data: any[];
}

export const getWebhookSecretsAction = () => {
  return {
    type: WebhookSecretsAction.GET_WEBHOOK_SECRETS_OPTIONS,
    payload: {}
  };
};
export const getWebhookSecretsLoadingAction = () => loadingAction(WebhookSecretsAction.GET_WEBHOOK_SECRETS_OPTIONS_LOADING);

export const getWebhookSecretsErrorAction = (error: string) => errorAction(WebhookSecretsAction.GET_WEBHOOK_SECRETS_OPTIONS_ERROR, error);

export const getWebhookSecretsSuccessAction = (data: WebhookSecretsSchema) => {
  const payload: WebhookSecretsSchema = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: WebhookSecretsAction.GET_WEBHOOK_SECRETS_OPTIONS_SUCCESS,
    payload: payload
  };
};

export interface SavePeriodicSchema {
  ExpirationFrequencyType: string;
  ExpirationFrequency: number;
}
export interface PeriodicSchema extends SideEffectSchema {
  ExpirationFrequencyType: string;
  ExpirationFrequency: number;
}

//---------------------------------------------------------------------
export interface SavePasswordHistorySchema {
  MaxPassWordHistory: number;
}
export interface PasswordHistory extends SideEffectSchema {
  MaxPassWordHistory: number;
}

export interface MFASecurityQuestionsSchema extends SideEffectSchema, V2ErrorResponseSchema {
  MinimumQuestionsToAsk?: number;
  QuestionsCount?: number;
  IsEnabled?: boolean;
}

export const getMfaSecurityQuestionsAction = () => {
  return {
    type: MFASecurityQuestionsAction.GET_MFA_SECURITY_QUESTIONS,
    payload: {}
  };
};
export const getMfaSecurityQuestionsLoadingAction = () => loadingAction(MFASecurityQuestionsAction.GET_MFA_SECURITY_QUESTIONS_LOADING);

export const getMfaSecurityQuestionsErrorAction = (error: string) => errorAction(MFASecurityQuestionsAction.GET_MFA_SECURITY_QUESTIONS_ERROR, error);

export const getMfaSecurityQuestionsSuccessAction = (data: MFASecurityQuestionsSchema) => {
  const payload: MFASecurityQuestionsSchema = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: MFASecurityQuestionsAction.GET_MFA_SECURITY_QUESTIONS_SUCCESS,
    payload: payload
  };
};

export const updateMfaSecurityQuestionsAction = (data: MFASecurityQuestionsSchema) => {
  return {
    type: UpdateMFASecurityQuestionsAction.UPDATE_MFA_SECURITY_QUESTIONS,
    payload: data
  };
};
export const updateMfaSecurityQuestionsLoadingAction = () => loadingAction(UpdateMFASecurityQuestionsAction.UPDATE_MFA_SECURITY_QUESTIONS_LOADING);

export const updateMfaSecurityQuestionsErrorAction = (error: string) => errorAction(UpdateMFASecurityQuestionsAction.UPDATE_MFA_SECURITY_QUESTIONS_ERROR, error);

export const updateMfaSecurityQuestionsSuccessAction = (data: MFASecurityQuestionsSchema) => {
  const payload: MFASecurityQuestionsSchema = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: UpdateMFASecurityQuestionsAction.UPDATE_MFA_SECURITY_QUESTIONS_SUCCESS,
    payload: payload
  };
};

export interface MFAAuthenticatorAppsSchema extends SideEffectSchema, V2ErrorResponseSchema {
  AccountSecretKey?: string;
  QrCodeWidth?: number;
  QrCodeHeight?: number;
  IsEnabled?: boolean;
  IssuerId?: string;
}

export const getMfaAuthenticatorAppsAction = () => {
  return {
    type: MFAAuthenticatorAppsAction.GET_MFA_AUTHENTICATOR_APPS,
    payload: {}
  };
};
export const getMfaAuthenticatorAppsLoadingAction = () => loadingAction(MFAAuthenticatorAppsAction.GET_MFA_AUTHENTICATOR_APPS_LOADING);

export const getMfaAuthenticatorAppsErrorAction = (error: string) => errorAction(MFAAuthenticatorAppsAction.GET_MFA_AUTHENTICATOR_APPS_ERROR, error);

export const getMfaAuthenticatorAppsSuccessAction = (data: MFAAuthenticatorAppsSchema) => {
  const payload: MFAAuthenticatorAppsSchema = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: MFAAuthenticatorAppsAction.GET_MFA_AUTHENTICATOR_APPS_SUCCESS,
    payload: payload
  };
};

export const updateMfaAuthenticatorAppsAction = (data: MFAAuthenticatorAppsSchema) => {
  return {
    type: UpdateMFAAuthenticatorAppsAction.UPDATE_MFA_AUTHENTICATOR_APPS,
    payload: data
  };
};
export const updateMfaAuthenticatorAppsLoadingAction = () => loadingAction(UpdateMFAAuthenticatorAppsAction.UPDATE_MFA_AUTHENTICATOR_APPS_LOADING);

export const updateMfaAuthenticatorAppsErrorAction = (error: string) => errorAction(UpdateMFAAuthenticatorAppsAction.UPDATE_MFA_AUTHENTICATOR_APPS_ERROR, error);

export const updateMfaAuthenticatorAppsSuccessAction = (data: MFAAuthenticatorAppsSchema) => {
  const payload: MFAAuthenticatorAppsSchema = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: UpdateMFAAuthenticatorAppsAction.UPDATE_MFA_AUTHENTICATOR_APPS_SUCCESS,
    payload: payload
  };
};

export interface MFASettingsSchema extends SideEffectSchema, V2ErrorResponseSchema {
  IsGoogleAuthenticatorEnabled?: boolean;
  IsRequired?: boolean;
  IsSecondFactorAuthenticatorEnabled?: boolean;
}

export const getMfaSettingsAction = () => {
  return {
    type: mfaSettingsAction.GET_MFA_SETTINGS,
    payload: {}
  };
};
export const getMfaSettingsLoadingAction = () => loadingAction(mfaSettingsAction.GET_MFA_SETTINGS_LOADING);

export const getMfaSettingsErrorAction = (error: string) => errorAction(mfaSettingsAction.GET_MFA_SETTINGS_ERROR, error);

export const getMfaSettingsSuccessAction = (data: MFASettingsSchema) => {
  const payload: MFASettingsSchema = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: mfaSettingsAction.GET_MFA_SETTINGS_SUCCESS,
    payload: payload
  };
};

export const updateMfaSettingsAction = (data: MFAAuthenticatorAppsSchema) => {
  return {
    type: updateMFASettingsAction.UPDATE_MFA_SETTINGS,
    payload: data
  };
};
export const updateMfaSettingsLoadingAction = () => loadingAction(updateMFASettingsAction.UPDATE_MFA_SETTINGS_LOADING);

export const updateMfaSettingsErrorAction = (error: string) => errorAction(updateMFASettingsAction.UPDATE_MFA_SETTINGSS_ERROR, error);

export const updateMfaSettingsSuccessAction = (data: MFASettingsSchema) => {
  const payload: MFASettingsSchema = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: updateMFASettingsAction.UPDATE_MFA_SETTINGS_SUCCESS,
    payload: payload
  };
};

export interface MFAEmailOTPStatusSchema extends SideEffectSchema, V2ErrorResponseSchema {
  IsEnabled?: boolean;
}

export const getMfaEmailOtpStatusAction = () => {
  return {
    type: mfaEmailOtpStatusAction.GET_MFA_EMAIL_STATUS,
    payload: {}
  };
};
export const getMfaEmailOtpStatusLoadingAction = () => loadingAction(mfaEmailOtpStatusAction.GET_MFA_EMAIL_STATUS_LOADING);

export const getMfaEmailOtpStatusErrorAction = (error: string) => errorAction(mfaEmailOtpStatusAction.GET_MFA_EMAIL_STATUS_ERROR, error);

export const getMfaEmailOtpStatusSuccessAction = (data: MFAEmailOTPStatusSchema) => {
  const payload: MFAEmailOTPStatusSchema = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: mfaEmailOtpStatusAction.GET_MFA_EMAIL_STATUS_SUCCESS,
    payload: payload
  };
};

export const updateMfaEmailOtpStatusAction = (data: MFAEmailOTPStatusSchema) => {
  return {
    type: updateMFAEmailOtpStatusAction.UPDATE_MFA_EMAIL_STATUS,
    payload: data
  };
};
export const updateMfaEmailOtpStatusLoadingAction = () => loadingAction(updateMFAEmailOtpStatusAction.UPDATE_MFA_EMAIL_STATUS_LOADING);

export const updateMfaEmailOtpStatusErrorAction = (error: string) => errorAction(updateMFAEmailOtpStatusAction.UPDATE_MFA_EMAIL_STATUS_ERROR, error);

export const updateMfaEmailOtpStatusSuccessAction = (data: MFAEmailOTPStatusSchema) => {
  const payload: MFAEmailOTPStatusSchema = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: updateMFAEmailOtpStatusAction.UPDATE_MFA_EMAIL_STATUS_SUCCESS,
    payload: payload
  };
};

export interface MFASmsOTPStatusSchema extends SideEffectSchema, V2ErrorResponseSchema {
  IsEnabled?: boolean;
}

export const getMfaSmsOtpStatusAction = () => {
  return {
    type: mfaSmsOtpStatusAction.GET_MFA_SMS_STATUS,
    payload: {}
  };
};
export const getMfaSmsOtpStatusLoadingAction = () => loadingAction(mfaSmsOtpStatusAction.GET_MFA_SMS_STATUS_LOADING);

export const getMfaSmsOtpStatusErrorAction = (error: string) => errorAction(mfaSmsOtpStatusAction.GET_MFA_SMS_STATUS_ERROR, error);

export const getMfaSmsOtpStatusSuccessAction = (data: MFASmsOTPStatusSchema) => {
  const payload: MFASmsOTPStatusSchema = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: mfaSmsOtpStatusAction.GET_MFA_SMS_STATUS_SUCCESS,
    payload: payload
  };
};

export const updateMfaSmsOtpStatusAction = (data: MFASmsOTPStatusSchema) => {
  return {
    type: updateMFASmsOtpStatusAction.UPDATE_MFA_SMS_STATUS,
    payload: data
  };
};
export const updateMfaSmsOtpStatusLoadingAction = () => loadingAction(updateMFASmsOtpStatusAction.UPDATE_MFA_SMS_STATUS_LOADING);

export const updateMfaSmsOtpStatusErrorAction = (error: string) => errorAction(updateMFASmsOtpStatusAction.UPDATE_MFA_SMS_STATUS_ERROR, error);

export const updateMfaSmsOtpStatusSuccessAction = (data: MFASmsOTPStatusSchema) => {
  const payload: MFASmsOTPStatusSchema = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: updateMFASmsOtpStatusAction.UPDATE_MFA_SMS_STATUS_SUCCESS,
    payload: payload
  };
};

export interface PushNotificationSchema extends SideEffectSchema, V2ErrorResponseSchema {
  IsEnabled?: boolean;
  Message?: string;
  QRCodeWidth?: number;
  NotificationService?: string;
  CustomAppName?: string;
  AWSsettings: {
    AccessKeyId?: string;
    SecretAccessKey?: string;
    Region?: string;
  };
  AndroidSettings: {
    Enabled: false;
    PlaystoreUrl?: string;
    IsServiceJsonPresent?: boolean;
    PlatformARN?: string;
    ServiceJson?: string;
  };
  IOSsettings: {
    Enabled?: boolean;
    AppstoreUrl?: string;
    BundleId?: string;
    IsApnsCertPresent?: boolean;
    Environment?: string;
    PlatformARN?: string;
    ApnsCertificate?: string;
  };
}

export const getPushNotificationAction = () => {
  return {
    type: pushNotificationAction.GET_PUSH_NOTIFICATION,
    payload: {}
  };
};
export const getPushNotificationLoadingAction = () => loadingAction(pushNotificationAction.GET_PUSH_NOTIFICATION_LOADING);

export const getPushNotificationErrorAction = (error: string) => errorAction(pushNotificationAction.GET_PUSH_NOTIFICATION_ERROR, error);

export const getPushNotificationSuccessAction = (data: PushNotificationSchema) => {
  const payload: PushNotificationSchema = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: pushNotificationAction.GET_PUSH_NOTIFICATION_SUCCESS,
    payload: payload
  };
};

export const addPushNotificationAction = (data: PushNotificationSchema) => {
  return {
    type: addpushNotificationAction.ADD_PUSH_NOTIFICATION,
    payload: data
  };
};
export const addPushNotificationLoadingAction = () => loadingAction(addpushNotificationAction.ADD_PUSH_NOTIFICATION_LOADING);

export const addPushNotificationErrorAction = (error: string) => errorAction(addpushNotificationAction.ADD_PUSH_NOTIFICATION_ERROR, error);

export const addPushNotificationSuccessAction = (data: PushNotificationSchema) => {
  const payload: PushNotificationSchema = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: addpushNotificationAction.ADD_PUSH_NOTIFICATION_SUCCESS,
    payload: payload
  };
};

export const updatePushNotificationAction = (data: PushNotificationSchema) => {
  return {
    type: updatepushNotificationAction.UPDATE_PUSH_NOTIFICATION,
    payload: data
  };
};
export const updatePushNotificationLoadingAction = () => loadingAction(updatepushNotificationAction.UPDATE_PUSH_NOTIFICATION_LOADING);

export const updatePushNotificationErrorAction = (error: string) => errorAction(updatepushNotificationAction.UPDATE_PUSH_NOTIFICATION_ERROR, error);

export const updatePushNotificationSuccessAction = (data: PushNotificationSchema) => {
  const payload: PushNotificationSchema = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: updatepushNotificationAction.UPDATE_PUSH_NOTIFICATION_SUCCESS,
    payload: payload
  };
};

export interface DuoAuthenticationSchema extends SideEffectSchema, V2ErrorResponseSchema {
  IsEnabled: boolean;
  ClientId?: string;
  ClientSecret?: string;
  APIHost?: string;
}

export const getDuoAuthenticationAction = () => {
  return {
    type: duoAuthenticationAction.GET_DUO_AUTHENTICATION,
    payload: {}
  };
};
export const getduoAuthenticationLoadingAction = () => loadingAction(duoAuthenticationAction.GET_DUO_AUTHENTICATION_LOADING);

export const getduoAuthenticationErrorAction = (error: string) => errorAction(duoAuthenticationAction.GET_DUO_AUTHENTICATION_ERROR, error);

export const getduoAuthenticationSuccessAction = (data: DuoAuthenticationSchema) => {
  const payload: DuoAuthenticationSchema = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: duoAuthenticationAction.GET_DUO_AUTHENTICATION_SUCCESS,
    payload: payload
  };
};

export const updateDuoAuthenticationAction = (data: DuoAuthenticationSchema) => {
  return {
    type: updateduoAuthenticationAction.UPDATE_DUO_AUTHENTICATION,
    payload: data
  };
};
export const updateDuoAuthenticationLoadingAction = () => loadingAction(updateduoAuthenticationAction.UPDATE_DUO_AUTHENTICATION_LOADING);

export const updateDuoAuthenticationErrorAction = (error: string) => errorAction(updateduoAuthenticationAction.UPDATE_DUO_AUTHENTICATION_ERROR, error);

export const updateDuoAuthenticationSuccessAction = (data: DuoAuthenticationSchema) => {
  const payload: DuoAuthenticationSchema = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: updateduoAuthenticationAction.UPDATE_DUO_AUTHENTICATION_SUCCESS,
    payload: payload
  };
};

/** Breached Password */
interface BreachedPassword {
  IsEnabled: boolean;
  Login: {
    IsEnabled: boolean;
    Action: string;
  };
  Registration: {
    IsEnabled: boolean;
  };
  PasswordChange: {
    IsEnabled: boolean;
  };
  AdminNotifications: {
    Events: string[];
    EmailIds: string[];
  };
}
export interface BreachedPasswordSchema extends SideEffectSchema {
  data: BreachedPassword;
}
export const getBreachedPasswordPolicyAction = () => {
  return {
    type: PasswordPolicyAction.GET_BREACHED_PASSWORD_POLICY,
    payload: {}
  };
};
export const getBreachedPasswordPolicyLoadingAction = () => loadingAction(PasswordPolicyAction.GET_BREACHED_PASSWORD_POLICY_LOADING);

export const getBreachedPasswordPolicyErrorAction = (error: string) => errorAction(PasswordPolicyAction.GET_BREACHED_PASSWORD_POLICY_ERROR, error);

export const getBreachedPasswordPolicySuccessAction = (data: BreachedPassword) => {
  const payload: BreachedPasswordSchema = {
    data,
    ...successSideEffectState
  };
  return {
    type: PasswordPolicyAction.GET_BREACHED_PASSWORD_POLICY_SUCCESS,
    payload: payload
  };
};

export const postBreachedPasswordPolicyAction = (data: any) => {
  return {
    type: PasswordPolicyAction.POST_BREACHED_PASSWORD_POLICY,
    payload: data
  };
};
export const postBreachedPasswordPolicyLoadingAction = () => loadingAction(PasswordPolicyAction.POST_BREACHED_PASSWORD_POLICY_LOADING);

export const postBreachedPasswordPolicyErrorAction = (error: string) => errorAction(PasswordPolicyAction.POST_BREACHED_PASSWORD_POLICY_ERROR, error);

export const postBreachedPasswordPolicySuccessAction = (data: BreachedPassword) => {
  const payload: BreachedPasswordSchema = {
    data,
    ...successSideEffectState
  };
  return {
    type: PasswordPolicyAction.POST_BREACHED_PASSWORD_POLICY_SUCCESS,
    payload: payload
  };
};

export const syncBreachedPasswordConfigAction = (payload: any) => {
  return {
    type: PasswordPolicyAction.SYNC_BREACHED_PASSWORD_CONFIG,
    payload: payload
  };
};

export interface CaptchaSettingsSchema extends SideEffectSchema, V2ErrorResponseSchema, APIErrorResponseSchema {
  IsEnabled: boolean;
  QQTencentCaptcha: {
    PublicKey: string;
    PrivateKey: string;
  };
  GoogleRecaptchaV2: {
    PublicKey: string;
    PrivateKey: string;
  };
  GoogleRecaptchaV3: {
    Threshold: number;
    PublicKey: string;
    PrivateKey: string;
  };
  HCaptcha: {
    IsInvisibleCaptcha: boolean;
    Threshold: number;
    IsDarkTheme: boolean;
    PublicKey: string;
    PrivateKey: string;
  };
  EnabledCaptcha: string;
}
export const getCaptchaSettingsAction = () => {
  return {
    type: getCaptchaSettingAction.GET_CAPTCHA_SETTING,
    payload: {}
  };
};
export const getCaptchaSettingsLoadingAction = () => loadingAction(getCaptchaSettingAction.GET_CAPTCHA_SETTING_LOADING);

export const getCaptchaSettingsErrorAction = (error: string) => errorAction(getCaptchaSettingAction.GET_CAPTCHA_SETTING_ERROR, error);

export const getCaptchaSettingsSuccessAction = (data: CaptchaSettingsSchema) => {
  const payload: CaptchaSettingsSchema = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: getCaptchaSettingAction.GET_CAPTCHA_SETTING_SUCCESS,
    payload: payload
  };
};

export const updateCaptchaSettingsAction = (data: CaptchaSettingsSchema) => {
  return {
    type: updateCaptchaSettingAction.UPDATE_CAPTCHA_SETTING,
    payload: data
  };
};
export const updateCaptchaSettingsLoadingAction = () => loadingAction(updateCaptchaSettingAction.UPDATE_CAPTCHA_SETTING_LOADING);

export const updateCaptchaSettingsErrorAction = (error: string) => errorAction(updateCaptchaSettingAction.UPDATE_CAPTCHA_SETTING_ERROR, error);

export const updateCaptchaSettingsSuccessAction = (data: CaptchaSettingsSchema) => {
  const payload: CaptchaSettingsSchema = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: updateCaptchaSettingAction.UPDATE_CAPTCHA_SETTING_SUCCESS,
    payload: payload
  };
};

export interface UpdateForceLogoutSettingSchema {
  data: any[];
}

export const updateForceLogoutSettingAction = (payload: UpdateForceLogoutSettingSchema) => {
  return {
    type: updateForceLogoutSettingConstAction.UPDATE_FORCE_LOGOUT,
    payload: { ...payload }
  };
};

export const updateForceLogoutSettingLoadingAction = () => {
  return loadingAction(updateForceLogoutSettingConstAction.UPDATE_FORCE_LOGOUT_LOADING);
};

export const updateForceLogoutSettingSuccessAction = (data: any) => {
  const payload = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: updateForceLogoutSettingConstAction.UPDATE_FORCE_LOGOUT_SUCCESS,
    payload
  };
};

export const updateForceLogoutSettingErrorAction = (error: string) => {
  return errorAction(updateForceLogoutSettingConstAction.UPDATE_FORCE_LOGOUT_ERROR, error);
};

export interface UpdateRemeberMeSettingSchema {
  IsRememberMe?: boolean;
  RememberMeTokenExpiry?: number;
}

export const updateRemeberMeSettingAction = (payload: UpdateRemeberMeSettingSchema) => {
  return {
    type: updateRemeberMeSettingConstAction.UPDATE_REMEBER_ME,
    payload: { ...payload }
  };
};

export const updateRemeberMeSettingLoadingAction = () => {
  return loadingAction(updateRemeberMeSettingConstAction.UPDATE_REMEBER_ME_LOADING);
};

export const updateRemeberMeSettingSuccessAction = (data: any) => {
  const payload = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: updateRemeberMeSettingConstAction.UPDATE_REMEBER_ME_SUCCESS,
    payload
  };
};

export const updateRemeberMeSettingErrorAction = (error: string) => {
  return errorAction(updateRemeberMeSettingConstAction.UPDATE_REMEBER_ME_ERROR, error);
};

export interface UpdateSessionLimitSettingSchema {
  SessionsLimit: number;
  Enabled: boolean;
}

export const updateSessionLimitAction = (payload: UpdateSessionLimitSettingSchema) => {
  return {
    type: updateSessionLimitSettingAction.UPDATE_SESSION_LIMIT,
    payload: { ...payload }
  };
};

export const updateSessionLimitLoadingAction = () => {
  return loadingAction(updateSessionLimitSettingAction.UPDATE_SESSION_LIMIT_LOADING);
};

export const updateSessionLimitSuccessAction = (data: any) => {
  const payload = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: updateSessionLimitSettingAction.UPDATE_SESSION_LIMIT_SUCCESS,
    payload
  };
};

export const updateSessionLimitErrorAction = (error: string) => {
  return errorAction(updateSessionLimitSettingAction.UPDATE_SESSION_LIMIT_ERROR, error);
};
